import { render, staticRenderFns } from "./TagForm.vue?vue&type=template&id=768b29c9&"
import script from "./TagForm.vue?vue&type=script&lang=ts&"
export * from "./TagForm.vue?vue&type=script&lang=ts&"
import style0 from "./TagForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports